import { DefaultTheme } from 'styled-components';

import colors from '../colors';
import { rgba } from 'polished';

const light: DefaultTheme['variants']['light'] = {
  white: colors.whites.white1,
  gray: colors.blacks.black2,
  midGray: rgba(colors.grays.gray8, 0.6),
  lightGray: colors.grays.gray8,
  black: colors.blacks.black3,
  blackActive: colors.blacks.black1,
  blackHover: colors.blacks.black8,
  primary: colors.blacks.black3,
  primaryHover: colors.blacks.black1,
  secondary: colors.grays.gray7,
  secondaryHover: colors.grays.gray6,
  secondaryDark: colors.grays.gray2,
  tertiary: colors.grays.gray3,
  accent: colors.reds.red1,
  accentLight: colors.reds.red0,
  accentHover: colors.reds.red3,
  success: colors.greens.green7,
  successButton: colors.greens.green6,
  successText: colors.greens.green4,
  successLight: colors.greens.green2,
  successDark: colors.greens.green3,
  error: colors.reds.red1,
  divider: colors.grays.gray0,
  header: colors.whites.white1,
  headerBorder: colors.grays.gray12,
  background: colors.grays.gray8,
  differentBackground: colors.whites.white1,
  blackBackground: colors.blacks.black1,
  border: colors.grays.gray6,
  box: colors.grays.gray13,
  hint: colors.hints.hint1,
  hintText: colors.hints.hint2,
  hintLight: colors.hints.hint3,
  hintDark: colors.hints.hint4,
  logo: colors.reds.red1,
  shadow: rgba(colors.grays.gray5, 0.5),
  upload: colors.oranges.orange1,
  iconBackground: rgba(colors.blacks.black2, 0.05),
  iconBackgroundHover: colors.grays.gray6,
  inputBackground: colors.whites.white1,
  inputBackgroundAlternate: colors.grays.gray13,
  inputBackgroundAlternateDark: colors.grays.gray7,
  menuBackground: colors.grays.gray10,
  darkBackground: colors.grays.gray12,
  cardPillBg: colors.hints.hint5,
  cardPillText: colors.hints.hint6,
  pureBlackWhite: colors.blacks.black6,
  dropdownBG: rgba(colors.blacks.black0, 0.05),
  darkDropdownHoverBG: colors.blacks.black8,
  inputLabel: colors.grays.gray3,
  circleBgIcon: colors.grays.gray8,
  blogBg: colors.blues.blue0,
  blueColor: colors.blues.blue1,
  blueColorDark: colors.blues.blue2,
  green: colors.greens.green7,
  greenLight: colors.greens.green0,
  purple: colors.purples.purple1,
  whiteInv: colors.whites.white1,
  planTextBackground: colors.hints.hint7,
  moneyChip: colors.grays.gray1,
  subscriptionBoxText: colors.grays.gray3,
  datePickerBackground: colors.blacks.black2,
  darkDropdown: colors.blacks.black9,
  // Social Media
  facebook: colors.socialMedia.facebook,
  twitter: colors.socialMedia.twitter,
  google: colors.socialMedia.google,
  apple: colors.socialMedia.apple,
  // Credit Cards
  visa: colors.cards.visa,
  mastercard: colors.cards.mastercard,
  amex: colors.cards.amex,
  diners: colors.cards.diners,
  discover: colors.cards.discover,
  jcb: colors.cards.jcb,
  unionpay: colors.cards.unionpay,
  // Privacy Policy Colors
  privacyPolicyBackground: colors.grays.gray8,
  privacyPolicyLastUpdated: colors.grays.gray3,
  blackButton: colors.blacks.black2,
  blackButtonText: colors.grays.gray3,
  pink: colors.reds.red6,
};

export default light;
